﻿define(function () {
    'use strict';
    var method,
        noop = function () { },
        methods = [
            'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
            'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
            'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
            'timeStamp', 'trace', 'warn'],
        length = methods.length,
        log = (window.console = window.console || {});

    while (length--) {
        method = methods[length];
        // Only stub undefined methods.
        if (!log[method]) {
            log[method] = noop;
        }
    }

    return log;
});


//////////////////
// WEBPACK FOOTER
// ./libs/log.js
// module id = 3
// module chunks = 2